import { Component, forwardRef, Inject, Input } from '@angular/core';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { CapricornService }         from './capricorn.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { MessagesService }          from '../messages/messages.service';

@Component({
  selector   : 'wor-capricorn-create-csv',
  template: require('./capricorn.create-csv.component.html')
})
export class CapricornCreateCsvComponent {
  @Input() integrations: CompanyIntegrationsModel;

  endDate  : string = '';
  startDate: string = '';

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => CapricornService))
    private capricornService: CapricornService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  download () : void {
    this.capricornService.downloadCsv(this.startDate, this.endDate);

    this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CAPRICORN.DOWNLOADED_UPLOAD_TO_CAPLINK'), 'success');

    this.activeModal.close();
  }
}
